import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PopupService } from 'src/app/services/popup/popup.service';
declare var $:any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit,OnDestroy {
  popups:any[];
  sub:Subscription;
  images = [
    { src: 'image1.jpg' },
    { src: 'image2.jpg' },
    { src: 'image3.jpg' },
    { src: 'image4.jpg' },
    { src: 'image5.jpg' },
    { src: 'image5.jpg' }
  ];
  // date:Date= new Date(new Date().getTime() + (8.5 * 60 * 60 * 1000));
  date:Date = new Date();
  isDateValid =false;
  currentSlideIndex = 0;
  constructor(private router:Router,private popupService:PopupService) { }

  ngOnInit(): void {
    // if((this.date.getTime() - new Date(1648431588676).getTime())>=0){
    //   this.isDateValid=true;
    // }
    this.popupService.getPopupList();
    this.sub = this.popupService.popupList.snapshotChanges().subscribe(
      list=>{
      this.popups=  list.map(item=>{ return {
        $key:item.key,
        ... item.payload.val()
      }
       })
       if(this.popups.length !== 0){
        this.popups= this.popups.sort((a,b)=> a.position - b.position);
        // console.log(this.popups)
        $("#myModal").modal('show');
       }
       
      }
    );
    
  }

  prevSlide() {
    this.currentSlideIndex = (this.currentSlideIndex - 1 + this.images.length) % this.images.length;
  }

  nextSlide() {
    this.currentSlideIndex = (this.currentSlideIndex + 1) % this.images.length;
  }
  onSubmit(){
   
    this.router.navigate(['/admission/entrance-result']);
    $('#myModal').modal('hide');
  }
  ngOnDestroy(): void {
    $('#myModal').modal('hide');
  }

}
